import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTaxaOpcionalComponent } from './card-taxa-opcional.component';
import { CheckboxModule } from '@vip/ui/checkbox';

@NgModule({
  imports: [CommonModule, CheckboxModule],
  declarations: [CardTaxaOpcionalComponent],
  exports: [CardTaxaOpcionalComponent],
})
export class CardTaxaOpcionalModule {}
